import { styled } from "styled-components";

import { redundantCssFromKebab } from "../../styles/redundant-css";

export const Section = styled.section`
    ${redundantCssFromKebab("padding-bottom", "2rem")}
    ${redundantCssFromKebab("overflow", "visible")}
`;
